/*!

=========================================================
* Argon Dashboard PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import CompanyList from "../views/pages/company/List";
import CompanyCreate from "../views/pages/company/Create";
import CompanyEdit from "../views/pages/company/Edit";
import ContactCreate from "../views/pages/contact/Create";
import ContactList from "../views/pages/contact/List";
import ContactDetails from "../views/pages/contact/Details";
import ContactEdit from "../views/pages/contact/Edit";
import CompanyDetails from "../views/pages/company/Details";
import routeVisibleForRole from "../util/routeVisibleForRole";
import Profile from "../views/pages/auth/Profile";
import SubscribedUserDashboard from "../views/pages/dashboards/SubscribedUserDashboard";
import ReviewCompanyDetails from "../views/pages/subscribedUser/reviewCompany/Details";
import ReviewCompanyEdit from "../views/pages/subscribedUser/reviewCompany/Edit";
import ReviewCompanyList from "../views/pages/subscribedUser/reviewCompany/List";
import ReviewCompanyCreate from "../views/pages/subscribedUser/reviewCompany/Create";
import ReviewContactDetails from "../views/pages/subscribedUser/reviewContact/Details";
import ReviewContactEdit from "../views/pages/subscribedUser/reviewContact/Edit";
import ReviewContactCreate from "../views/pages/subscribedUser/reviewContact/Create";
import ReviewContactList from "../views/pages/subscribedUser/reviewContact/List";
import UserSettings from "../views/pages/settings/UserSettings";
import Trends from "../views/pages/reviews/Trends";
import AudienceList from "../views/pages/subscribedUser/reviewContact/AudienceList";
import UnansweredContacts from "../views/pages/reviews/UnansweredContacts";

const subscribedUserRoutes = [
    {
        collapse: false,
        path: "/dashboard",
        name: "Dashboard",
        icon: "fa fa-tachometer",
        component: SubscribedUserDashboard,
        layout: "/user",
        invisible: !routeVisibleForRole(["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]),
    }, {
        collapse: true, // Indicates that this is a collapsible group
        state: "companyCollapse", // State key for controlling collapse
        name: "Company", // Name of the collapsible group
        icon: "fa fa-solid fa-building ", // Icon for the collapsible group
        invisible: !routeVisibleForRole(["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]),
        views: [ // Array of routes that are part of this collapsible group
            {
                collapse: false,
                path: "/company/show/:uniqueId",
                name: "Company Details",
                icon: " ",
                component: ReviewCompanyDetails,
                layout: "/user",
                invisible: true,
            },
            {
                collapse: false,
                path: "/company/edit/:uniqueId",
                name: "Company Edit",
                icon: " ",
                component: ReviewCompanyEdit,
                layout: "/user",
                invisible: true,
            },
            {
                collapse: false,
                path: "/company/list",
                name: "List All Companies",
                icon: " ",
                component: ReviewCompanyList,
                layout: "/user",
                invisible: !routeVisibleForRole(["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"])
            },
            {
                collapse: false,
                path: "/company/create",
                name: "Create New Company",
                icon: " ",
                component: ReviewCompanyCreate,
                layout: "/user",
                invisible: !routeVisibleForRole(["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]),
            },
        ],
    },
    {
        collapse: true, // Indicates that this is a collapsible group
        state: "contactCollapse", // State key for controlling collapse
        name: "Contact Database", // Name of the collapsible group
        icon: "fa fa-solid fa-address-book ", // Icon for the collapsible group
        invisible: !routeVisibleForRole(["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]),
        views: [
            {
                collapse: false,
                path: "/contact/show/:uniqueId",
                name: "Contact Details",
                icon: " ",
                component: ReviewContactDetails,
                layout: "/user",
                invisible: true,
            },
            {
                collapse: false,
                path: "/contact/edit/:uniqueId",
                name: "Contact Edit",
                icon: " ",
                component: ReviewContactEdit,
                layout: "/user",
                invisible: true,
            },
            {
                collapse: false,
                path: "/contact/create/:uniqueId",
                name: "Contact Create",
                icon: " ",
                component: ReviewContactCreate,
                layout: "/user",
                invisible: true,
            },
            {
                collapse: false,
                path: "/contact/list",
                name: "List All Contacts",
                icon: " ",
                component: ReviewContactList,
                layout: "/user",
            },
            {
                collapse: false,
                path: "/contact/create/",
                name: "Create New Contact",
                icon: " ",
                component: ReviewContactCreate,
                layout: "/user",
                invisible: false,
            },
        ],
    },
    {
        collapse: true, // Indicates that this is a collapsible group
        state: "reviewsCollapse", // State key for controlling collapse
        name: "Reviews", // Name of the collapsible group
        icon: "fa fa-solid fa-building ", // Icon for the collapsible group
        invisible: !routeVisibleForRole(["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]),
        views: [ // Array of routes that are part of this collapsible group
            {
                collapse: false,
                path: "/trends",
                name: "Trends",
                icon: " ",
                component: Trends,
                layout: "/user",
                invisible: false,
            },
            {
                collapse: false,
                path: "/audience/list",
                name: "Audience List",
                icon: " ",
                component: AudienceList,
                layout: "/user",
                invisible: !routeVisibleForRole(["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"])
            },
            {
                collapse: false,
                path: "/unanswered",
                name: "UnAnswered",
                icon: " ",
                component: UnansweredContacts,
                layout: "/user",
                invisible: !routeVisibleForRole(["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"])
            },
        ],
    },
    {
        collapse: false,
        path: "/profile",
        name: "Profile",
        icon: " ",
        component: Profile,
        layout: "/user",
        invisible: true
    },
    {
        collapse: false,
        path: "/settings",
        name: "Settings",
        icon: " ",
        component: UserSettings,
        layout: "/user",
        invisible: true
    },

];


export default subscribedUserRoutes;
